import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { generateSearchUrl } from 'shared/helpers/urls';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import * as formActions from 'shared/actions/searchForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LinkList from 'shared/components/LinkList/LinkList';
import SeoTexts from 'shared/components/SeoTexts/SeoTexts';
import s from './SeoLinks.css';

class SeoLinks extends React.Component {
  static propTypes = {
    currentPath: PropTypes.string,
    selected: PropTypes.shape(),
    linkPrefixParams: PropTypes.shape({}).isRequired,
    location: PropTypes.shape(),
    selectedActions: PropTypes.shape().isRequired,
    isMobile: PropTypes.bool,
    seoText: PropTypes.string,
    characteristics: PropTypes.shape({
      categories: PropTypes.arrayOf(PropTypes.shape()),
      engines: PropTypes.arrayOf(PropTypes.shape()),
      gearboxes: PropTypes.arrayOf(PropTypes.shape()),
      transport_categories: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
  };
  static defaultProps = {
    currentPath: '',
    seoText: '',
    location: null,
    selected: null,
    isMobile: false,
  };

  buildLink = slug => {
    const { linkPrefixParams, location } = this.props;

    return [generateSearchUrl(linkPrefixParams), slug, location && location.slug]
      .filter(i => !!i)
      .join('/')
      .replace(/\/\//g, '/');
  };

  clearYearsFilter = () => {
    const { selected, selectedActions } = this.props;

    if (selected.yearFrom || selected.yearTo) {
      selectedActions.set.yearFrom(null);
      selectedActions.set.yearTo(null);
    }
  };

  buildTechLink = slug => {
    const { linkPrefixParams, location } = this.props;
    const linkPrefix = generateSearchUrl({ transport: linkPrefixParams.transport });

    return [linkPrefix, slug, location && location.slug]
      .filter(i => !!i)
      .join('/')
      .replace(/\/\//g, '/');
  };

  handleTypeClick = () => {
    this.props.selectedActions.set.make(null);
    this.props.selectedActions.set.model(null);
  };

  render() {
    const { characteristics, selected, location, isMobile, seoText, currentPath } = this.props;
    const { categories = [], engines, gearboxes, transport_categories: types } = characteristics;
    const { transport, isNew } = selected;

    const isAuto = transport && transport.slug === 'avto';
    const isUsedAuto = isAuto && !isNew;
    const isCountry = location && location.is_country;

    return (
      <div className={s.root}>
        {isUsedAuto && !isCountry && (
          <div>
            <LinkList
              title={<FormattedMessage id={'Типы кузова'} />}
              onClick={this.clearYearsFilter}
              buildLink={this.buildLink}
              isMobile={isMobile}
              list={categories}
              lensEvent="carBodySelect"
            />
            <LinkList
              title={<FormattedMessage id={'Типы топлива'} />}
              buildLink={this.buildLink}
              isMobile={isMobile}
              list={engines}
              lensEvent="carEngineSelect"
            />
            <LinkList
              title={<FormattedMessage id={'Коробки передач'} />}
              buildLink={this.buildLink}
              isMobile={isMobile}
              list={gearboxes}
              lensEvent="carGearboxSelect"
            />
            {seoText && Object.keys(seoText).length && (
              <SeoTexts
                buildLink={this.buildLink}
                isMobile={isMobile}
                list={gearboxes}
                seoText={seoText}
                currentPath={currentPath}
              />
            )}
          </div>
        )}
        <SeoTexts isMobile={isMobile} currentPath={currentPath} />
        {!isAuto && types && (
          <LinkList
            title={<FormattedMessage id={'Типы кузова'} />}
            buildLink={isAuto ? this.buildLink : this.buildTechLink}
            onClick={!isAuto ? this.handleTypeClick : undefined}
            isMobile={isMobile}
            list={types}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = ({ searchForm, history }) => ({
  selected: searchForm && searchForm.selected,
  currentPath: history.currentPath,
});
const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.carSetThunks,
      },
      dispatch,
    ),
  },
});

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SeoLinks),
);



// WEBPACK FOOTER //
// ./src/shared/components/SeoLinks/SeoLinks.js